















import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { ROUTER_NAME } from '../../router'
import { userState } from '../../stores/user'

@Component({})
export default class HeaderUser extends Vue {
  ROUTER_NAME = ROUTER_NAME
  get user() {
    return userState.user
  }
  private tab(page) {
    this.$router.push({
      name: page
    })
  }
}
